import { graphql } from '../gql';
import { useQuery } from '@apollo/client';
import type { ThreatActorFilterInput, PaginationRequest } from '../gql/graphql';

export const GET_THREAT_ACTORS = graphql(`
  query getThreatActors($pagination: PaginationRequest) {
    threatActors(pagination: $pagination) {
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`);

export interface IUseThreatActorsQueryArgs {
  filters?: ThreatActorFilterInput;
  pagination?: PaginationRequest;
}

export function useThreatActorsQuery(args?: IUseThreatActorsQueryArgs) {
  const { loading, data, error, refetch } = useQuery(GET_THREAT_ACTORS, {
    variables: {
      pagination: args?.pagination,
    },
  });

  return {
    loading,
    error,
    data,
    refetch,
  };
}
